import ChevronLeft from "@/assets/ChevronLeft.svg";
import ChevronRight from "@/assets/ChevronRight.svg";
import { LogoCard, Title } from "@/ui";
import clsx from "classnames";
import { chunk } from "lodash";
import { Carousel, Col, Container, Row } from "react-bootstrap";
import classes from "./styles.module.scss";
import { simple_pages_helper } from "@/helpers/simple_pages_helper";

export const LogoCarousel = ({ className, title, uniqueLogos, button, bgColor, titleColor, logosPerSlide }) => {
  const page = simple_pages_helper.find("homepage")?.carousel_items;

  const items =
    uniqueLogos && uniqueLogos.length > 0
      ? uniqueLogos.map((i) => ({
          title: i["title"],
          img: i["img"]?.url,
          href: i["link"] ?? "#",
        }))
      : page.map((i) => ({
          title: i["title"],
          img: typeof i["image"] === "string" ? i["image"] : i["image"]?.url ?? null,
          href: i["link"] ?? "#",
        }));

  return (
    <div className={clsx(className, classes.employers, `bg-${bgColor}`)}>
      <Container className="mw-xxl">
        <Title title={title} className={clsx(`text-${titleColor}`)} />
        <Carousel
          className={classes.employers__carousel}
          controls={true}
          prevIcon={<ChevronLeft width="14" height="25" />}
          nextIcon={<ChevronRight width="14" height="25" />}
        >
          {chunk(items, logosPerSlide).map((group, k) => (
            <Carousel.Item key={k}>
              <Row>
                {group.map(({ img, title, href }, idx) => (
                  <Col key={idx} className="py-3">
                    <a className={clsx(className, classes.card)} href={href}>
                      <img className="mw-100" src={img} size="x228" alt={title ?? "Carousel item"} />
                    </a>
                  </Col>
                ))}
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>
        <div className={classes.employers__footer}>
          {button && (
            <a className={classes.employers__link} href={button.href}>
              {button.label}
              <ChevronRight width="7" height="13" className="ms-2" />
            </a>
          )}
        </div>
      </Container>
    </div>
  );
};

export default LogoCarousel;
